<template>
  <div>
    <section
      class="bg-white container d-flex flex-column align-items-center py-lg-space-xxl py-space-lg px-auto"
    >
      <div class="col-12 col-md-8 d-flex flex-column">
        <h3 class="h3-small mb-space-xxs text-center">
          {{ titleLabelText }}
        </h3>
      </div>
      <div class="col-12 col-md-8 d-flex flex-column mb-space-xs">
        <h1 class="h1-large text-center">
          {{ title }}
        </h1>
      </div>
      <div class="col-12 col-md-6 mb-space-md">
        <div class="learningExperience text-center" v-html="description"></div>
      </div>
      <button @click="handleLinkClick" class="btn btn-primary fs-medium">
        {{ link.text }}
      </button>
      <div
        class="row flex-wrap justify-content-center my-space-lg w-100 px-gutter px-lg-0 px-md-0"
      >
        <div class="col-lg-5 col-12 p-0 feedback-content">
          <div>
            <p
              class="fs-large feedback-points fw-bold mb-lg-space-sm mb-space-md px-space-xs px-lg-0"
            >
              “It was a much more
              <span
                class="custom-background px-0"
                data-aos="custom-background"
                data-aos-easing="ease"
                data-aos-duration="2000"
              >
                interactive <br class="tab-break" />experience
              </span>
              than I expected.”
            </p>
            <p
              class="fs-large feedback-points fw-bold mb-lg-space-sm mb-space-md px-space-xs px-lg-0"
            >
              “I
              <span
                class="custom-background px-0"
                data-aos="custom-background"
                data-aos-easing="ease"
                data-aos-duration="2000"
              >
                made a lot of connections</span
              >
              <br class="tab-break" />
              along the way.”
            </p>
            <p
              class="fs-large feedback-points fw-bold mb-lg-space-sm mb-space-md px-space-xs px-lg-0"
            >
              “As soon as I was a part of the <br class="tab-break" />
              ASU community,
              <span
                class="custom-background px-0"
                data-aos="custom-background"
                data-aos-easing="ease"
                data-aos-duration="2000"
                >I was supported.</span
              >”
            </p>
          </div>
        </div>
        <div class="col-lg-2 custom-line p-0 mx-space-lg"></div>
        <div class="col-lg-5 col-12 p-0">
          <div>
            <p
              class="fs-large feedback-points fw-bold mb-lg-space-sm mb-space-md px-space-xs px-lg-0"
            >
              “The professors
              <span
                class="custom-background px-0"
                data-aos="custom-background"
                data-aos-easing="ease"
                data-aos-duration="2000"
              >
                genuinely care</span
              >
              <br class="tab-break" />about student learning.”
            </p>
            <p
              class="fs-large feedback-points fw-bold mb-lg-space-sm mb-space-md px-space-xs px-lg-0"
            >
              “They
              <span
                class="custom-background px-0"
                data-aos="custom-background"
                data-aos-easing="ease"
                data-aos-duration="2000"
              >
                care about me,</span
              >
              <br class="tab-break" />my goals and my ambitions.”
            </p>
            <p
              class="fs-large feedback-points fw-bold mb-lg-space-sm mb-0 px-space-xs px-lg-0"
            >
              “ASU has been the perfect fit for me, I would
              <span
                class="custom-background m-0 p-0 px-0"
                data-aos="custom-background"
                data-aos-easing="ease"
                data-aos-duration="2000"
              >
                recommend it to anyone.
              </span>
              ”
            </p>
          </div>
        </div>
      </div>
      <div class="break-line"></div>
    </section>
  </div>
</template>
<script setup lang="ts">
import type { ParagraphHtmlLink } from "@/server/resolvers/resolvers-types";
import { analyticsComposable } from "@rds-vue-ui/analytics-gs-composable";
import AOS from "aos";
import "aos/dist/aos.css";
import { onMounted } from "vue";

const props = defineProps<{
  title: string;
  titleLabelText: string;
  description: string;
  link: ParagraphHtmlLink;
}>();

const emit = defineEmits<{
  (e: "btn-click", event: Event, id: string): void;
}>();

onMounted(() => {
  AOS.init({ once: true });
});

const handleLinkClick = (e: Event) => {
  const { title, link } = props;
  analyticsComposable.trackLinkEvent(
    "internal link",
    "main content",
    title.toLowerCase(),
    link.text.toLowerCase()
  );
  emit("btn-click", e, link.uri);
};
</script>
<style scoped>
.custom-line {
  background-color: var(--rds-light-4);
  width: 2px;
  height: auto;
  min-height: 100%;
}

.break-line {
  background-color: var(--rds-light-4);
  width: auto;
  min-width: 100%;
  height: 2px;
  /* min-height: 100%; */
  margin: 0 20px;
}

.tab-break {
  display: none;
}

@media screen and (min-width: 1200px) {
  .feedback-points {
    font-size: 24px !important;
  }
}

@media screen and (min-width: 992px) {
  .break-line {
    display: none;
  }
  .feedback-content {
    display: flex;
    justify-content: end;
  }
}

@media (min-width: 1024px) {
  .tab-break {
    display: block;
  }
}
:deep(.learningExperience p) {
  margin-bottom: 0px;
}

:deep([data-aos="custom-background"]) {
  background-size: 0% 100%;
  transition: background-size 0.5s ease;
}

:deep([data-aos="custom-background"].aos-animate) {
  background-size: 100% 100%;
}
</style>
